// UX fix (Jaime 2026-09-18): the PWA added-to-homescreen starts at
// start_url "/" which used to always show the marketing landing even for
// logged-in users. While AuthProvider restores the session (or silently
// refreshes it) we keep rendering the landing to avoid a flash; once the
// session is confirmed we redirect to the same role-aware destination the
// login flow uses. Logged-out visitors keep seeing the landing untouched.
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getPostLoginDestinationFromStorage } from '../lib/postLoginDestination';
import LandingPage from '../pages/LandingPage';

export function RootAuthGate() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <LandingPage />;
  if (isAuthenticated) return <Navigate to={getPostLoginDestinationFromStorage()} replace />;
  return <LandingPage />;
}
